export const generateAccuracyMessagesEn = {
  'adminProjects.generateAccuracy.header.allProjects': 'All projects',
  'adminProjects.generateAccuracy.header.accuracyService': 'Accuracy service',
  'adminProjects.generateAccuracy.header.title': 'Generate accuracy results',
  'adminProjects.generateAccuracy.header.description':
    'Run the accuracy service to compare model extractions against the reference standard. Configure the run below, then generate to compute precision, recall and F1 per concept group.',

  'adminProjects.generateAccuracy.optimizationProject.label': 'Optimization project',

  'adminProjects.generateAccuracy.recommended': 'Recommended',

  'adminProjects.generateAccuracy.batch.title': 'Batch type',
  'adminProjects.generateAccuracy.batch.description':
    'Choose which annotated batch of this project to evaluate against.',
  'adminProjects.generateAccuracy.batch.loadError': 'Failed to load batches. Please try again.',
  'adminProjects.generateAccuracy.batch.finalEval': 'Final eval',
  'adminProjects.generateAccuracy.batch.encounterCount': '{count} encounters',
  'adminProjects.generateAccuracy.batch.completedCount':
    'Encounters completed {completed} / {total}',
  'adminProjects.generateAccuracy.batch.testBatchWarning':
    "You're running against the <strong>reserved test set</strong>. Repeated runs can inflate reported accuracy. Reserve this for final evaluation only.",
  'adminProjects.generateAccuracy.batch.switchToValidation': 'Switch to Validation',
  'adminProjects.generateAccuracy.batch.noEligibleBatches': 'No eligible batches for the project.',

  'adminProjects.generateAccuracy.testBatchDialog.title': 'Run against the reserved test set?',
  'adminProjects.generateAccuracy.testBatchDialog.body':
    'The test set ({count, number} encounters) is reserved for final evaluation. For iteration and tuning, use the Validation batch instead.',
  'adminProjects.generateAccuracy.testBatchDialog.acknowledge':
    'I understand this is a final evaluation run.',
  'adminProjects.generateAccuracy.testBatchDialog.cancel': 'Cancel',
  'adminProjects.generateAccuracy.testBatchDialog.confirm': 'Use test set',

  'adminProjects.generateAccuracy.model.title': 'Extraction model',
  'adminProjects.generateAccuracy.model.description':
    'The model that will run the extractions for this accuracy iteration.',
  'adminProjects.generateAccuracy.model.loadError': 'Failed to load models. Please try again.',
  'adminProjects.generateAccuracy.model.placeholder': 'Select a model',
  'adminProjects.generateAccuracy.model.selectABatchFirst': 'Select a batch first',
  'adminProjects.generateAccuracy.model.openWeights': 'open weights',

  'adminProjects.generateAccuracy.branch.label': 'GitHub branch',
  'adminProjects.generateAccuracy.branch.description':
    'The ai-prompts branch to source the prompt from.',
  'adminProjects.generateAccuracy.branch.loadError': 'Failed to load branches. Please try again.',
  'adminProjects.generateAccuracy.branch.placeholder': 'Select a branch',

  'adminProjects.generateAccuracy.prompt.title': 'Extraction prompt',
  'adminProjects.generateAccuracy.prompt.description':
    'The prompt used to extract concepts from the encounters.',
  'adminProjects.generateAccuracy.prompt.loadError': 'Failed to load prompts. Please try again.',
  'adminProjects.generateAccuracy.prompt.placeholder': 'Select a prompt',
  'adminProjects.generateAccuracy.prompt.selectModelFirst': 'Select a model first',
  'adminProjects.generateAccuracy.prompt.viewPrompt': 'View prompt',

  'adminProjects.generateAccuracy.viewPromptDialog.subtitle': '{branch} @ {sha}',
  'adminProjects.generateAccuracy.viewPromptDialog.loadError':
    'Failed to load prompt body. Please try again.',

  'adminProjects.generateAccuracy.description.title': 'Job run description',
  'adminProjects.generateAccuracy.description.description':
    'A label to identify this accuracy job run on the dashboard. Auto-generated from your selections — edit if needed.',
  'adminProjects.generateAccuracy.description.placeholder':
    'Select a batch, model and prompt to auto-generate',
  'adminProjects.generateAccuracy.description.reset': 'Reset to auto-generated description',
  'adminProjects.generateAccuracy.description.composedTemplate':
    '{batchTypeLabel} run using {modelLabel} with the {promptLabel} prompt',
  'adminProjects.generateAccuracy.description.composedTemplateWithBranch':
    '{batchTypeLabel} run using {modelLabel} with the {promptLabel} prompt (branch: {branchLabel})',
  'adminProjects.generateAccuracy.description.completePrevStepsFirst':
    'Complete previous steps first',

  'adminProjects.generateAccuracy.footer.completeAllSteps': 'Complete all steps to generate.',
  'adminProjects.generateAccuracy.footer.generate': 'Generate accuracy',
  'adminProjects.generateAccuracy.footer.generating': 'Generating...',

  'adminProjects.generateAccuracy.submitError': 'Failed to generate accuracy. Please try again.',
};
